import { MAP_LIMITS } from "../constants/config";

export const BRUSH_SIZE_VALUE_CODES = {
  3: 'tiny',
  6: 'small',
  12: 'medium',
  18: 'large',
};

/**
 * Preload an array of image URLs for better UX
 * @param {string[]} urls - Array of image URLs to preload
 */
export const preloadImages = (urls) => {
  urls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

/**
 * Calculate map dimensions based on window size and API limits
 * @param {number} windowWidth - Window inner width
 * @param {number} windowHeight - Window inner height
 * @returns {{ width: number, height: number }} - Calculated dimensions
 */
export const getMapDimensions = (windowWidth, windowHeight) => {
  const { maxDimension, breakpoint } = MAP_LIMITS;

  return {
    width: windowWidth <= breakpoint ? windowWidth : maxDimension,
    height: windowHeight <= breakpoint ? windowHeight : maxDimension,
  };
};

/**
 * Extract rooftop address from geocode results
 * Prioritizes ROOFTOP location type for most accurate address
 * Works with both REST API and JavaScript API Geocoder responses
 * @param {Object} geocodeResponse - Geocoding response
 * @returns {string|null} - Formatted address or null if not found
 */
export const extractRooftopAddress = (geocodeResponse) => {
  if (geocodeResponse?.status !== "OK") {
    return null;
  }

  const records = geocodeResponse.results || [];
  const rooftop = records.find((record) => {
    // Handle both REST API format and JavaScript API format
    const locationType = record.geometry?.location_type;
    return locationType === "ROOFTOP" || locationType === window.google?.maps?.GeocoderLocationType?.ROOFTOP;
  });

  return rooftop?.formatted_address || null;
};

/**
 * Get the current measurement based on mode
 * @param {string} mode - "area" or "perimeter"
 * @param {number} area - Coverage square area
 * @param {number} distance - Linear distance drawn
 * @returns {number} - The appropriate measurement value
 */
export const getMeasurement = (mode, area, distance) => {
  return mode === "area" ? area : distance;
};